import { KeyAsString } from 'type-fest'

import { FilterValue } from 'components/Filter'
import {
  AdUnitBidder,
  AdUnitParameter,
  AdUnitParameters,
} from 'features/globalSetup/types/adUnitBidder'
import { YieldbirdStatus } from 'features/globalSetup/types/yieldbirdStatus'
import { AdUnit } from 'features/inventory/types/adUnit'
import { AdUnitBidderSlice } from '../../hooks/UseGetAdUnitBidders'
import { DomainBidderSlice } from '../../hooks/useGetDomainBidder'

export type AdUnitsForTable = Pick<
  AdUnitBidder,
  'alerts' | 'csEnabled' | 'csParams' | 'id' | 's2sEnabled' | 's2sParams' | 'updatedAt'
> & {
  adUnit: Pick<AdUnit, 'divId' | 'id' | 'path' | 'ybAdUnitEnabled'>
}

export type AdUnitSortBy = KeyAsString<
  Pick<AdUnitsForTable, 'csEnabled' | 's2sEnabled' | 'updatedAt'> & {
    'adUnit.divId': Pick<AdUnit, 'divId'>
    'adUnit.path': Pick<AdUnit, 'path'>
  }
>

export type AdUnitsTableProps = {
  domainBidder: DomainBidderSlice
  filters: FilterValue[]
}

export type Params = {
  cs: {
    csParams?: AdUnitParameters
    csRequiredParamsNames: AdUnitParameter['name'][]
  }
  s2s: {
    s2sParams?: AdUnitParameters
    s2sRequiredParamsNames: AdUnitParameter['name'][]
  }
}

export type UseColumnsProps = Params & {
  adUnitBidders: AdUnitBidderSlice[]
  workspaceStatus: YieldbirdStatus
}

export const paramsDefaults: Params = {
  cs: {
    csParams: undefined,
    csRequiredParamsNames: [],
  },
  s2s: {
    s2sParams: undefined,
    s2sRequiredParamsNames: [],
  },
}
